import { render, staticRenderFns } from "./ExpressBanner.vue?vue&type=template&id=558064d2"
import script from "./ExpressBanner.vue?vue&type=script&lang=js"
export * from "./ExpressBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports